var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.9999 0C26.3893 0 34 7.61175 34 17.0001C34 26.3894 26.3893 34 16.9999 34C7.61058 34 0 26.3893 0 17.0001C0 7.61175 7.61069 0 16.9999 0Z","fill":"#8A8A8A","key":0}),React.createElement("path",{"d":"M19.4295 10.9979H22V7H18.9784V7.01442C15.3171 7.15095 14.5668 9.31786 14.5006 11.5938H14.4931V13.5901H12V17.5053H14.4931V28H18.2503V17.5053H21.3281L21.9226 13.5901H18.2515V12.384C18.2515 11.6148 18.7376 10.9979 19.4295 10.9979Z","fill":"#161616","key":1})]);
}

FacebookIcon.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
